import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-title"
}
const _hoisted_2 = { class: "data-table" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]

import { computed, onMounted, ref, watch } from "vue";
import { styleZoom } from "@/common/utils/style";
import { fileAvatarFileShow } from "@/common/api/rest/file/avatar";


export default /*@__PURE__*/_defineComponent({
  __name: 'table-block',
  props: {
    block: {},
    selectedBlock: {},
    zoom: {}
  },
  setup(__props: any) {

const props = __props;

/** Cache de imagens legadas (value = id → data URL) */
const images = ref<{ [key: string]: string }>({});

const columns = computed(() =>
  (props.block?.content?.columns ?? []).filter((col: any) => !!col.visible),
);

const rows = computed(() =>
  (props.block?.content?.rows ?? [])
    .filter((row: any) => !!row.visible)
    .filter((row: any) =>
      (row.items ?? []).some((item: any) => {
        const col = columns.value.find((c: any) => c.id === item.col);
        return col && col.visible;
      }),
    ),
);

/**
 * Resolve a URL final para exibir uma imagem.
 * - Se `value` já for uma data URL (o editor já resolveu), usa direto.
 * - Se for um objeto com { file, mime_type } → monta data URL.
 * - Se for um objeto com { base64 } → usa direto.
 * - Caso contrário (legado), trata como ID e busca no cache `images`.
 */
function resolveImageSrc(value: any): string {
  if (!value) return "";

  if (typeof value === "string") {
    if (value.startsWith("data:")) return value;
    return images.value[value] ?? "";
  }

  if (value.file) {
    return `data:${value.mime_type ?? "image/png"};base64,${value.file}`;
  }

  if (value.base64) return value.base64;

  return "";
}

/**
 * Busca via API apenas os valores que:
 *  - são strings (IDs legados)
 *  - NÃO são data URLs
 *  - ainda não estão no cache
 */
async function getImages() {
  const idsToFetch = new Set<string>();

  (props.block?.content?.rows ?? []).forEach((row: any) => {
    (row?.items ?? []).forEach((item: any) => {
      if (!item?.is_image) return;

      const value = item.value;
      if (typeof value !== "string") return;
      if (!value) return;
      if (value.startsWith("data:")) return; // já resolvido pelo editor
      if (images.value[value]) return; // já em cache

      idsToFetch.add(value);
    });
  });

  const ids = Array.from(idsToFetch);
  if (ids.length === 0) return;

  const promises = ids.map((id) =>
    fileAvatarFileShow(props.block.account_id, id),
  );

  const response = await Promise.all(promises);

  response.forEach((res, index) => {
    // guarda contra res.data nulo (id inválido)
    if (res?.success && res.data?.base64) {
      images.value[ids[index]] = res.data.base64;
    }
  });
}

watch(
  () => props.block,
  async () => {
    if (!props.block) return;
    await getImages();
  },
  { deep: true, immediate: true },
);

onMounted(async () => {
  if (!props.block) return;
  await getImages();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-block", { selected: !!__props.selectedBlock }]),
    style: _normalizeStyle(_unref(styleZoom)(__props.block.style, __props.zoom))
  }, [
    (__props.block.content?.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.block.content?.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
            return (_openBlock(), _createElementBlock("th", {
              key: col.id
            }, _toDisplayString(col.label), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: row.id
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.items, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.id
              }, [
                (columns.value.some((c) => c.id === item.col))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
                      (item.is_image)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (resolveImageSrc(item.value))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "cell-image",
                                  src: resolveImageSrc(item.value)
                                }, null, 8, _hoisted_4))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(" - ")
                                ], 64))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (item.value !== null && item.value !== '')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(item.value), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(" - ")
                                ], 64))
                          ], 64))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ], 6))
}
}

})